export default ({ icon, text, onClick }: { icon: React.ReactNode; text: string; onClick?: React.MouseEventHandler<HTMLButtonElement> }) => {
  return (
    <button className='flex flex-col items-center gap-1 p-5 border-none rounded-lg bg-white cursor-pointer' onClick={onClick}>
      {icon}
      <span className='text-sm text-[#696969]'>{text}</span>
    </button>
  );
};
